{
  "$comment": "Canonical face-region map for Roblox classic clothing templates. Measured directly from Roblox's official Classic-Clothing-Templates.zip by tools/measure_template.py on 2026-08-09. Roblox publishes region SHAPES but has never published these coordinates.",
  "source": {
    "url": "https://prod.docsiteassets.roblox.com/assets/accessories/classic-clothing/Classic-Clothing-Templates.zip",
    "files": [
      "Template-Shirts-R15.png",
      "Template-Pants-R15.png"
    ],
    "note": "Shirt and pants templates are geometrically IDENTICAL - same 18 rectangles, same fill colours. Only the labels and illustration differ. One region map serves both."
  },
  "canvas": {
    "width": 585,
    "height": 559
  },
  "gutter": {
    "px": 2,
    "note": "Every pair of adjacent regions is separated by a uniform 2px unpainted gutter. Roblox's docs state these borders exist so clothes appear without a seam - dilate artwork INTO them on export rather than treating them as forbidden."
  },
  "faceColors": {
    "#00A2FF": "up",
    "#F68802": "down",
    "#E2231A": "front",
    "#0074BD": "back",
    "#02B757": "right",
    "#F6B702": "left"
  },
  "regions": {
    "torso.up": {
      "x": 231,
      "y": 8,
      "w": 128,
      "h": 64
    },
    "torso.right": {
      "x": 165,
      "y": 74,
      "w": 64,
      "h": 128
    },
    "torso.front": {
      "x": 231,
      "y": 74,
      "w": 128,
      "h": 128
    },
    "torso.left": {
      "x": 361,
      "y": 74,
      "w": 64,
      "h": 128
    },
    "torso.back": {
      "x": 427,
      "y": 74,
      "w": 128,
      "h": 128
    },
    "torso.down": {
      "x": 231,
      "y": 204,
      "w": 128,
      "h": 64
    },
    "rightLimb.up": {
      "x": 217,
      "y": 289,
      "w": 64,
      "h": 64
    },
    "rightLimb.left": {
      "x": 19,
      "y": 355,
      "w": 64,
      "h": 128
    },
    "rightLimb.back": {
      "x": 85,
      "y": 355,
      "w": 64,
      "h": 128
    },
    "rightLimb.right": {
      "x": 151,
      "y": 355,
      "w": 64,
      "h": 128
    },
    "rightLimb.front": {
      "x": 217,
      "y": 355,
      "w": 64,
      "h": 128
    },
    "rightLimb.down": {
      "x": 217,
      "y": 485,
      "w": 64,
      "h": 64
    },
    "leftLimb.up": {
      "x": 308,
      "y": 289,
      "w": 64,
      "h": 64
    },
    "leftLimb.front": {
      "x": 308,
      "y": 355,
      "w": 64,
      "h": 128
    },
    "leftLimb.left": {
      "x": 374,
      "y": 355,
      "w": 64,
      "h": 128
    },
    "leftLimb.back": {
      "x": 440,
      "y": 355,
      "w": 64,
      "h": 128
    },
    "leftLimb.right": {
      "x": 506,
      "y": 355,
      "w": 64,
      "h": 128
    },
    "leftLimb.down": {
      "x": 308,
      "y": 485,
      "w": 64,
      "h": 64
    }
  },
  "limbStripOrder": {
    "$comment": "The two limb strips are NOT mirror images of each other - the left strip is the right strip rotated by one position. This is the detail that makes naive left/right mirroring produce wrong results.",
    "rightLimb": [
      "left",
      "back",
      "right",
      "front"
    ],
    "leftLimb": [
      "front",
      "left",
      "back",
      "right"
    ]
  },
  "guideLines": {
    "$comment": "Full-width dotted rows detected in the template (x-span covers the whole region; narrow spans are label letters and were excluded).",
    "torso": {
      "absoluteY": 170,
      "offsetFromRegionTop": 96,
      "meaning": "UpperTorso / LowerTorso boundary, and simultaneously a drawn rule (82% of the row). UpperTorso = top 96px, LowerTorso = bottom 32px of the 128px torso regions.",
      "confidence": "high - independently corroborates the community R15 UV guidance (96/32 split)"
    },
    "limb": {
      "absoluteY": [
        407,
        446
      ],
      "offsetFromRegionTop": [
        52,
        91
      ],
      "meaning": "Roblox's stated maximum glove/shoe heights (pants template says shoes). RESOLVED 2026-08-09: these are NOT R15 part boundaries. The two questions are unrelated - see r15PartBands below. A full-row scan confirms only these two rows are true rules (84% of the row is dashes); the sparse marks at y=417/418 and y=427/428 are caption glyphs at 20-23% and are correctly excluded.",
      "confidence": "high"
    }
  },
  "r15PartBands": {
    "$comment": "How R15 subdivides each region. R15 is not a separate UV space - it is these same 18 regions sliced horizontally, so the editor needs a slice table rather than a new atlas. Offsets are from each region's top.",
    "$source": "Cross-checked against TheNextElectron/advanced-classic-clothing SpritemapR15.lua, which declares no licence - used for VERIFICATION ONLY. 17 of our 18 region origins matched it exactly. Re-measure the band offsets locally before shipping; do not vendor that file.",
    "$verified": false,
    "$verifyWith": "docs/research/diagnostic-capture-protocol.md",
    "torso": [
      {
        "part": "UpperTorso",
        "offset": 0,
        "height": 96,
        "absoluteBreakY": 170
      },
      {
        "part": "LowerTorso",
        "offset": 96,
        "height": 32
      }
    ],
    "limb": [
      {
        "part": "Upper",
        "offset": 0,
        "height": 63,
        "absoluteBreakY": 418
      },
      {
        "part": "Lower",
        "offset": 63,
        "height": 49,
        "absoluteBreakY": 467
      },
      {
        "part": "Extremity",
        "offset": 112,
        "height": 16,
        "note": "hand or foot"
      }
    ],
    "notes": [
      "Limb breaks at y=418 and y=467 are NOT drawn on the template - invisible to artists.",
      "The 64x64 up/down faces are not sliced; they belong wholly to the outermost part.",
      "The community figure of 64/48/16 is approximate; the real split is 63/49/16.",
      "Roblox stretches 1px rows at the joints (torso y=169 and y=201) to hide the seam."
    ]
  }
}
